var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.fileList.length == 1
        ? _c(
            "el-link",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.downloadFile(_vm.fileList[0])
                },
              },
            },
            [_vm._v(_vm._s(_vm.fileList[0].documentName))]
          )
        : _vm._e(),
      _vm.canEdit && _vm.fileList.length == 1
        ? _c(
            "el-link",
            {
              staticStyle: { "padding-left": "1em" },
              attrs: { type: "danger", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.delFile(_vm.fileList[0], 0)
                },
              },
            },
            [_vm._v("X")]
          )
        : _vm._e(),
      _vm.fileList.length > 1
        ? _c(
            "el-dropdown",
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v(" 文件列表(" + _vm._s(_vm.fileList.length) + ")"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.fileList, function (file, index) {
                  return _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(file)
                            },
                          },
                        },
                        [_vm._v(_vm._s(file.documentName))]
                      ),
                      _vm.canEdit
                        ? _c(
                            "el-link",
                            {
                              staticStyle: { "padding-left": "1em" },
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.delFile(file, index)
                                },
                              },
                            },
                            [_vm._v("X")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }